import { apiRequest } from './api.js';

const SESSION_LS = 'torre:session';
const SESSION_SS = 'torre:session';

let currentSession = null;

function wipeLegacyTokenStorage() {
  try { localStorage.removeItem(SESSION_LS); } catch {}
  try { sessionStorage.removeItem(SESSION_SS); } catch {}
}

function publicSession(user) {
  if (!user?.email) return null;
  return {
    id: user.id || null,
    email: user.email,
    name: user.name || 'Operador',
    role: user.role || 'admin',
    authenticated: true,
  };
}

export function getSession() {
  return currentSession;
}

export function persistSession(user) {
  currentSession = publicSession(user);
  wipeLegacyTokenStorage();
  return currentSession;
}

export function clearSession() {
  currentSession = null;
  wipeLegacyTokenStorage();
}

export async function restoreSession() {
  wipeLegacyTokenStorage();
  try {
    const data = await apiRequest('/auth/me');
    const user = data?.data;
    if (!user?.email) {
      clearSession();
      return null;
    }
    return persistSession(user);
  } catch {
    clearSession();
    return null;
  }
}

export async function signIn(email, password, remember) {
  const data = await apiRequest('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, remember: Boolean(remember) }),
  });
  const user = data?.data?.user || data?.data;
  if (!user?.email) throw new Error('Não foi possível autenticar.');
  return persistSession(user);
}

export async function signOut() {
  try {
    await apiRequest('/auth/logout', { method: 'POST' });
  } catch {}
  clearSession();
}

export async function requestPasswordRecovery(email) {
  return apiRequest('/auth/lost', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function validateResetToken(token) {
  const qs = new URLSearchParams({ token });
  return apiRequest(`/users/invite/validate?${qs}`);
}

export async function completePasswordReset({ token, password, passwordConfirmation }) {
  return apiRequest('/users/invite/complete', {
    method: 'POST',
    body: JSON.stringify({
      token,
      password,
      password_confirmation: passwordConfirmation,
    }),
  });
}

export function isAdmin(session = getSession()) {
  const role = String(session?.role || '').toLowerCase();
  return role === 'admin' || role === 'master';
}

export function initialsOf(session) {
  const n = String(session?.name || session?.email || '?').trim();
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return n.slice(0, 2).toUpperCase();
}
